import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import MenuPage from './pages/MenuPage';
import LandingPage from './pages/LandingPage';
import EstablishmentsPage from './pages/EstablishmentsPage';
import BookingPage from './pages/BookingPage';
import { ToastProvider } from './components/ui/Toast';

const App: React.FC = () => {
  return (
    <ToastProvider>
      <Router basename="/menu">
        <Switch>
          <Route path="/book/:establishmentId" exact component={BookingPage} />
          <Route path="/:establishmentId/table/:tableId" exact component={LandingPage} />
          <Route path="/:establishmentId/order/:tableId" component={MenuPage} />
          <Route path="/:establishmentId/view" component={MenuPage} />
          <Route path="/" exact component={EstablishmentsPage} />
        </Switch>
      </Router>
    </ToastProvider>
  );
};

export default App;